import { render, staticRenderFns } from "./AssignmentTableActions.vue?vue&type=template&id=0f057ca3&"
import script from "./AssignmentTableActions.vue?vue&type=script&lang=js&"
export * from "./AssignmentTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports